"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.trackTiming = exports.trackPageview = exports.trackException = exports.trackEvent = exports.set = exports.init = exports.getTracker = exports.addAutoLinker = void 0;
var _loadGA = _interopRequireDefault(require("./loadGA"));
var wrappedGA = function wrappedGA(tracker, command) {
  var _window;
  if (typeof window.ga !== 'function') {
    // eslint-disable-next-line no-console
    console.warn('Google Analytics is not defined, skipping command');
    return null;
  }
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  return (_window = window).ga.apply(_window, [tracker ? tracker + "." + command : command].concat(args));
};
var setFn = function setFn(tracker) {
  return function (options) {
    return wrappedGA(tracker, 'set', options);
  };
};
var sendFn = function sendFn(defaults) {
  return function (tracker) {
    return function (options) {
      return wrappedGA(tracker, 'send', Object.assign({
        anonymizeIp: true
      }, defaults, options));
    };
  };
};
var trackPageviewFn = sendFn({
  hitType: 'pageview',
  get page() {
    return document.location.pathname + document.location.search;
  },
  get hostname() {
    return document.location.hostname;
  }
});
var trackEventFn = sendFn({
  hitType: 'event'
});
var trackExceptionFn = sendFn({
  hitType: 'exception'
});
var trackTimingFn = sendFn({
  hitType: 'timing'
});
var addAutoLinkerFn = function addAutoLinkerFn(tracker) {
  return function (domain) {
    wrappedGA(tracker, 'require', 'linker');
    wrappedGA(tracker, 'linker:autoLink', [].concat(domain));
  };
};
var init = exports.init = function init(gaID, options) {
  if (options === void 0) {
    options = {};
  }
  var defaultOptions = {
    cookieDomain: 'auto',
    allowLinker: true
  };
  (0, _loadGA.default)();
  wrappedGA(undefined, 'create', gaID, Object.assign({}, defaultOptions, options));
};
var trackPageview = exports.trackPageview = trackPageviewFn();
var trackEvent = exports.trackEvent = trackEventFn();
var trackException = exports.trackException = trackExceptionFn();
var trackTiming = exports.trackTiming = trackTimingFn();
var set = exports.set = setFn();
var addAutoLinker = exports.addAutoLinker = addAutoLinkerFn();
var getTracker = exports.getTracker = function getTracker(tracker) {
  return {
    trackPageview: trackPageviewFn(tracker),
    trackEvent: trackEventFn(tracker),
    trackException: trackExceptionFn(tracker),
    trackTiming: trackTimingFn(tracker),
    set: setFn(tracker),
    addAutoLinker: addAutoLinkerFn(tracker)
  };
};